import { render, staticRenderFns } from "./PackageIndex.vue?vue&type=template&id=38a7512c"
import script from "./PackageIndex.vue?vue&type=script&lang=js"
export * from "./PackageIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports